import React, { createContext, useContext, useState } from 'react';

const ConnectionContext = createContext();

export function ConnectionProvider({ children }) {
    const [hasInsertedConnection, setHasInsertedConnection] = useState(false);

    return (
        <ConnectionContext.Provider value={{ hasInsertedConnection, setHasInsertedConnection }}>
            {children}
        </ConnectionContext.Provider>
    );
}

export function useConnection() {
    const context = useContext(ConnectionContext);
    if (!context) {
        throw new Error('useConnection must be used within a ConnectionProvider');
    }
    return context;
} 